<p-menu
  [showTransitionOptions]="'0ms'"
  [hideTransitionOptions]="'0ms'"
  [model]="menuitems"
></p-menu>
